// extracted by mini-css-extract-plugin
module.exports = {"footer":"style__footer__2SNqh","footerLower":"style__footerLower__VpPKm","links":"style__links__9NZnh","link":"style__link__l9Xkf","wrapper":"style__wrapper__K1GSD"};